<template>
  <v-container class="article-header pb-0 mt-3 mt-md-6" fluid>
    <div class="section_inner fill-height">
      <v-row align="stretch" justify="space-between" class="fill-height">
        <v-col cols="12" class="title-wrapper py-0 pr-2 mt-0">
          <h1 class="article-title display-42-20 primary--text">
            {{ item.title }}
          </h1>
        </v-col>
        <v-col cols="12" class="pt-0 pt-md-4 pb-0">
          <TipFooter :item="item" :font-size="'display-20-13'" />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import TipFooter from '@/components/Articles/TipFooter';

export default {
  components: {
    TipFooter,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.title-wrapper {
  overflow: hidden;
}
.article-header {
  background-color: #f1f0f2;
  height: 150px;
  overflow: hidden;
}

.article-title {
  font-weight: 500;
  overflow: hidden;
}

@media only screen and (max-width: 960px) {
  .article-header {
    min-height: 112px;
    height: auto;
  }

  .article-title {
    /* height: 55px; */
    line-height: 1.5;
    letter-spacing: -0.6px;
    font-weight: 100;
  }
}
</style>
